import { useCallback } from 'react'
import { useCurrentOrg } from '../../auth/hooks'
import { useFetch, useCreateApiNotification } from 'civic-champs-shared/api/hooks'
import { NamedRef } from 'civic-champs-shared/common/types'
import { useFeatureEnabled } from 'core/feature/hooks'

export const useRemoveQuestionnaire = (eagerRemove: any) => {
  const [request] = useFetch()
  const createNotification = useCreateApiNotification()
  const currentOrg = useCurrentOrg()
  const isQuestionnaireAsSurveyEnabled = useFeatureEnabled('QuestionnaireAsSurvey')
  const entityName = isQuestionnaireAsSurveyEnabled ? 'survey' : 'question-set'

  return useCallback(
    async (questionnaire: NamedRef) => {
      const undo = eagerRemove(questionnaire)
      const notification = createNotification('Removing questionnaire')
      try {
        // @ts-ignore
        await request({
          method: 'del',
          url: `/organizations/${currentOrg.id}/${entityName}/${questionnaire.id}`,
        })

        notification.onSuccess('Questionnaire removed!')
      } catch (error) {
        notification.onError(`Could not remove ${questionnaire.name} from questionnaires`, error)
        undo()
      }
    },
    [createNotification, currentOrg.id, eagerRemove, entityName, request],
  )
}

export default useRemoveQuestionnaire
